import clsx from "clsx";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { ContactType } from "../../../../lib/filters/dto";
import { keycloak } from "../../../../lib/keycloak";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { colors } from "../../../../ui/colors";
import { RotateIcon } from "../../../../ui/icons/rotate";
import { TrashIcon } from "../../../../ui/icons/trash";
import { ConfirmModal } from "../../../../ui/organisms/confirmModal.tsx";
import { NotFound } from "../../../../ui/organisms/notFound";
import { EventDTO, EventResponseDTO } from "../../../calendar/dto";
import { ProjectDTO } from "../../../projects/dto";
import { setShowRecallContactModal } from "../slice";
import { PlanRecallModal } from "./planRecallModal";
import { setOperationType } from "./slice";
import { recallSetter } from "./useRecall";
import { useDeleteRecallMutation } from "../../../../../features/recallsApi";
import { addBannerWithTimeout } from "../../../../lib/centralizedBanner/slice";

interface Props {
    contactType: ContactType
    title: string
    project: ProjectDTO
    contactId: string
    targetId: string
    recalls: EventResponseDTO
}

export function Recall(props: Props) {
    const { contactType, title, project, contactId, targetId, recalls } = props
    const dispatch = useAppDispatch()
    const [deleteRecall, { isLoading: isDeletingRecall }] = useDeleteRecallMutation()
    const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined)
    const handleDeleteRecall = async () => {
        try {
            await deleteRecall({ id: idToDelete!, contactId }).unwrap();
            dispatch(addBannerWithTimeout({
                variant: "success",
                message: "Evento eliminato con successo.",
            }));
            setIdToDelete(undefined);
        } catch (error) {
            dispatch(addBannerWithTimeout({
                variant: "error",
                message: "Si è verificato un errore durante l'eliminazione dell'evento.",
            }));
        }
    }
    const [data, setData] = useState<
        {
            selectionRange: string,
            notificationType: string,
            notificationInterval: string,
            notificationValue: number,
            date: Date | null,
            time: Date | null,
            note: string,
            id: string
        }>({
            selectionRange: '0',
            notificationType: '0',
            notificationInterval: '0',
            notificationValue: 15,
            date: null,
            time: null,
            note: '',
            id: ''
        })

    const recallsState = useAppSelector((state) => state.recalls)

    if (recalls?.paginationData.total === 0) {
        return (
            <div className="flex justify-center items-center h-3/4">
                <NotFound />
            </div>
        )
    }

    const handleClick = (recall: EventDTO) => {
        setData(recallSetter(recall)!)
        dispatch(setOperationType('edit'))
        dispatch(setShowRecallContactModal(true))

    }

    return (
        <div className="p-6 gap-2 flex flex-col ">
            {
                recalls?.data.map((recall, index) => (
                    <div className="p-3 flex flex-col gap-1 border border-neutral-200 hover:bg-neutral-50 rounded-lg" key={index}>
                        <div className="flex justify-between gap-2 items-center">
                            <div className="flex gap-2 items-center">
                                <div className="h-6 w-6 flex justify-center items-center rounded-full bg-white border border-neutral-200 cursor-pointer">
                                    <RotateIcon color={colors.neutral[500]} size={16} onClick={() => !keycloak.hasRealmRole('customer') && handleClick(recall)} />
                                </div>
                                <span className="text-text-sm font-semibold text-neutral-800">{format(recall.startDate, 'dd/MM/yyyy - HH:mm')}</span>
                            </div>
                            <div className={clsx("cursor-pointer", {
                                hidden: keycloak.hasRealmRole('customer')
                            })}>
                                <TrashIcon color={colors.red[500]} size={16} onClick={() => setIdToDelete(recall.id)} />
                            </div>
                        </div>
                        {
                            recall.notes &&
                            <span className="text-text-sm font-medium text-neutral-600 w-full crop-text">{recall.notes}</span>
                        }
                    </div>
                ))
            }
            {
                recallsState.operationType === 'edit' && <PlanRecallModal targetId={targetId} project={project} contactId={contactId} title={title} contactType={contactType} type={'edit'} data={data} />
            }
            <ConfirmModal
                title={"Elimina evento"}
                label={"Sei sicuro di voler eliminare questo evento?"}
                confirmAction={function (): void {
                    handleDeleteRecall()
                }}
                onClose={function (): void {
                    setIdToDelete(undefined)
                }}
                visible={idToDelete !== undefined}
            />
        </div>
    )
}